import * as React from 'react';
import styled from 'styled-components';
import * as T from '../../serviceTheme';
import { Styledes, Childable } from './types';

export interface Props extends Styledes, Childable {}

const Body = styled.div`
    padding: 25px 30px;
    overflow: auto;

    &::-webkit-scrollbar {
        width: 4px;
        padding: 1px;
    }

    &::-webkit-scrollbar-thumb {
        background: ${T.safeGetPrimary};
        border-radius: 40px 0px 0px 40px;
    }
`;


export default React.memo(({ children, className }: Props) => {
    return (
        <Body className={className}>
            {children}
        </Body>
    );
});
